import React from "react";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import Tag from "@/src/components/Tag/Tag";
import Container from "@/src/components/Container/Container";
import Section from "@/src/components/Section/Section";

export type TopicItem = {
  headline: string;
  subText: string;
};

export type TopicListProps = {
  legalArea: string;
  topics: TopicItem[];
};

export default function TopicList({ legalArea, topics }: TopicListProps) {
  return (
    <Section sx={(theme) => ({ backgroundColor: theme.palette.background.light, padding: { xs: 0, md: "8rem 0" } })}>
      <Container variant={"xl"}>
        <Grid container>
          <Grid size={{ xs: 12, md: 3 }}>
            <ChipLegalbird label={legalArea} />
            <Typography variant={"h4"} component={"h2"}>
              {`Wir unterstützen Sie im ${legalArea} bei den folgenden Themen`}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 8 }} offset={{ md: 1 }}>
            <Grid container rowSpacing={4} sx={{ justifyContent: "space-between" }}>
              {topics.map((topic) => (
                <Grid size={{ xs: 12, md: 5 }} key={topic.headline}>
                  <Stack>
                    <Divider sx={(theme) => ({ backgroundColor: theme.palette.divider })} />
                    <Tag label={topic.headline} sx={{ margin: "1.5rem 0" }} />
                    <Typography>{topic.subText}</Typography>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}
